export default __webpack_public_path__ + "static/media/tres-equis.4811ea56.jpg";